import inMemoryCacheFactory from '@/script/cache/utils'
import { prepareFormData } from './helpers/prepareFormData'
import { $axios, $payedAPI, apiList } from '@/api'
import {queryClient} from "@/query/queryClient";

export { prepareFormData }

export default {
    actions: {
        getCourseEnrolledUsers(_, payload) {
            const cacheName = 'course-users'
            const cacheRolesKey = payload.roles ? `-r:${JSON.stringify(payload.roles)}` : ''
            const cacheSearchKey = `-s:${payload.search}`
            const cachePageKey = payload.page ? `-p:${payload.page}` : '-'
            const cacheLimitKey = payload.limit ? `-l:${payload.limit}` : ''
            const cacheKey = `${payload.courseid}${cacheRolesKey}${cacheSearchKey}${cachePageKey}${cacheLimitKey}`
            const customCacheName = `${cacheName}-${cacheKey}`
            const cache = inMemoryCacheFactory(cacheName)

            if (cache.loading[customCacheName]) return cache.loading[customCacheName]

            const { resolved, notfound } = cache.read([cacheKey])


            if (notfound.length === 0) {
                return Promise.resolve(resolved[cacheKey])
            }

            return cache.loading[customCacheName] = new Promise((resolve, reject) => {
                $axios({
                    method: apiList.enroll.getEnrolledUsers.method,
                    params: {
                        wsfunction: apiList.enroll.getEnrolledUsers.moodle_method,
                        courseid: payload.courseid,
                        roles: payload.roles ? payload.roles.length > 0 ? payload.roles : ['all'] : ['all'],
                        search: payload.search ?? '',
                        page: payload.page ?? 0,
                        limit: payload.limit ?? 0
                    }
                })
                    .then(resp => {
                        cache.save({ [cacheKey]: resp.data })
                        resolve(resp.data)
                    })
                    .catch(err => {
                        cache.stop(customCacheName)
                        reject(err)
                    })
            })
        },

        /**
         *
         * @param {Object} context Vuex context object
         * @param {String | Number} courseId Course id (ex.: payload="15")
         * @returns
         */
        async getCourseTeachers({ dispatch }, courseId) {
            // debugger
            const cacheName = 'course-teachers'
            const customCacheName = `${cacheName}-${courseId}`

            const cache = inMemoryCacheFactory(cacheName)

            if (cache.loading[customCacheName]) return cache.loading[customCacheName]

            const { resolved, notfound } = cache.read([courseId])

            if (notfound.length === 0) {
                return Promise.resolve(resolved[courseId])
            }

            return cache.loading[customCacheName] = new Promise((resolve, reject) => {
                const data = {
                    id: courseId,
                    mode: 'course',
                    capability: 'moodle/course:viewparticipants'
                }

                dispatch('checkCapability', data).then((res) => {
                    if (res.isCapability) {
                        dispatch('getCourseEnrolledUsers', {
                            courseid: courseId,
                            roles: ['editingteacher', 'teacher', 'manager']
                        }).then(res => {
                            const teachers = { teacher: [], manager: [] }

                            if (!res.users.length) return teachers

                            res.users.forEach(el => {
                                if (el.id === 2) return // ** pass userid:2 (moodle admin system user)

                                if (el.roles.find(r => [3, 4].includes(r.id))) { // ** 3 - teacher, 4 - assistant, 1 - manager, 2 - course creator
                                    teachers.teacher.push(el)
                                }

                                if (el.roles.find(r => [1, 2].includes(r.id))) { // ** 3 - teacher, 4 - assistant, 1 - manager, 2 - course creator
                                    teachers.manager.push(el)
                                }
                            })

                            return teachers
                        }).then(teachers => {
                            cache.save({ [courseId]: teachers })
                            resolve(teachers)
                        }).catch(err => {
                            cache.stop(customCacheName)
                            reject(err)
                        })
                    } else {
                        resolve({ teacher: [], manager: [], error: 'Не доступно' })
                    }
                })
            })
        },

        getUserEnrolledCourses(_, userid) {
            const cacheName = `user-enrolled-courses`
            const customCacheName = `${cacheName}-${userid}`

            const cache = inMemoryCacheFactory(cacheName)
            if (cache.loading[customCacheName]) return cache.loading[customCacheName]

            const { resolved, notfound } = cache.read([userid])
            if (notfound.length === 0) {
                return Promise.resolve(resolved[userid])
            }

            return cache.loading[customCacheName] = new Promise((resolve, reject) => {
                if (!userid) {
                    resolve([])
                    return
                }

                $axios({
                    method: apiList.enroll.getEnrolledCourses.method,
                    params: {
                        wsfunction: apiList.enroll.getEnrolledCourses.moodle_method,
                        userid
                    }
                })
                    .then(resp => {
                        cache.save({ [userid]: resp.data })
                        resolve(resp.data)
                    }).catch(err => {
                    cache.stop(customCacheName)
                    reject(err)
                })
            })
        },

        getEnrolledCoursesByTime(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.enroll.getEnrolledCoursesByTime.method,
                    params: {
                        wsfunction: apiList.enroll.getEnrolledCoursesByTime.moodle_method,
                        classification: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data.courses)
                    }).catch(err => reject(err))
            })
        },

        getSelfEnrolmentsByCourseId(_, id) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.enroll.getEnrolmentsMethods.method,
                    params: {
                        wsfunction: apiList.enroll.getEnrolmentsMethods.moodle_method,
                        courseid: id
                    }
                })
                    .then(resp => {
                        resolve(resp.data.filter(e => e.type === 'self' && !!e.status))
                    }).catch(err => reject(err))
            })
        },

        getSelfEnrolInfo(_, id) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.enroll.getSelfEnrolInfo.method,
                    params: {
                        wsfunction: apiList.enroll.getSelfEnrolInfo.moodle_method,
                        instanceid: id
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        enrollToCourse({ getters, rootGetters }, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.enroll.enrollToCourse.method,
                    params: {
                        wsfunction: apiList.enroll.enrollToCourse.moodle_method,
                        courseid: payload.id,
                        password: payload?.password
                    }
                })
                    .then(resp => {
                        if (resp.data?.status) {
                            const userId = getters.user?.id || rootGetters.user?.id

                            queryClient.removeQueries({
                                queryKey: [`course-info-${payload.id}`],
                                exact: true
                            })

                            inMemoryCacheFactory('user-course-access')
                                .remove([`user-course-access-${payload.id}`])

                            if (userId) {
                                inMemoryCacheFactory('user-enrolled-courses')
                                    .remove([userId])
                            }
                        }

                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        unEnrollToCourse(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.enroll.unEnrollToCourse.method,
                    params: {
                        wsfunction: apiList.enroll.unEnrollToCourse.moodle_method,
                        ueid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        /**
         * New PayedCourses API
         *
         */
        checkCoursePaymentsStatus(_, courseid) {
            const cacheName = 'course-payment-status'
            const customCacheName = `${cacheName}-${courseid}`

            const cache = inMemoryCacheFactory(cacheName)
            if (cache.loading[customCacheName]) return cache.loading[customCacheName]

            const { resolved, notfound } = cache.read([courseid])
            if (notfound.length === 0) {
                return Promise.resolve(resolved[courseid])
            }

            return cache.loading[customCacheName] = new Promise((resolve, reject) => {
                courseid = notfound

                $payedAPI({
                    method: apiList.payedcourses.getCourseInfo.method,
                    url: apiList.payedcourses.getCourseInfo.action,
                    data: { id: courseid }
                })
                    .then(resp => {
                        if (resp.data?.data) {
                            cache.save({ [courseid]: resp.data.data })
                            resolve(resp.data.data)
                        } else {
                            reject(new Error(resp.data?.message || 'Payedcourse not found'))
                        }
                    }).catch(err => {
                    cache.stop(customCacheName)
                    reject(err)
                })
            })
        },
        getUserContractStatus() {
            return $payedAPI({
                method: apiList.payedcourses.getUserContractStatus.method,
                url: apiList.payedcourses.getUserContractStatus.action
            }).then(resp => resp.data)
        },
        /**
         * New PayedCourses API
         *
         */
        getUserContractPrint() {
            return new Promise((resolve, reject) => {
                $payedAPI({
                    method: apiList.payedcourses.getUserContractPrint.method,
                    url: apiList.payedcourses.getUserContractPrint.action,
                    headers: { 'Accept': 'application/pdf' },
                    responseType: 'blob'
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        /**
         * New PayedCourses API
         *
         */
        signUserContract() {
            return new Promise((resolve, reject) => {
                $payedAPI({
                    method: apiList.payedcourses.signUserContract.method,
                    url: apiList.payedcourses.signUserContract.action
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        /**
         * New PayedCourses API
         *
         */
        getPaymentLink(_, payload) {
            return new Promise((resolve, reject) => {
                $payedAPI({
                    method: apiList.payedcourses.getPaymentLink.method,
                    url: apiList.payedcourses.getPaymentLink.action,
                    params: Object.assign({ redirecturl: document.location.href }, payload)
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },
        addUserinfoToContract(_, payload) {
            return new Promise(async (resolve, reject) => {
                try {
                    // ** first, save extended info
                    const resp = await $payedAPI({
                        method: apiList.payedcourses.addUserinfoToContract.method,
                        url: apiList.payedcourses.addUserinfoToContract.action,
                        headers: {
                            'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'
                        },
                        data: prepareFormData(payload)
                    })
                    resolve(resp.data)
                } catch (err) {
                    reject(err)
                }
            })
        },
        registerContract(_, data) {
            return new Promise((resolve, reject) => {
                const form = new FormData()

                for (let [key, value] of Object.entries(data)) {
                    if (value instanceof File) {
                        form.append(key, value, value.name)
                    } else {
                        if (typeof value === 'object') {
                            value = JSON.stringify(value)
                        }
                        form.append(key, value)
                    }
                }

                $payedAPI({
                    method: apiList.payedcourses.registerContract.method,
                    url: apiList.payedcourses.registerContract.action,
                    headers: {
                        'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001'
                    },
                    data: form
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
